import * as Types from '@/types/bff/gql-schema';
import { UseInfiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useSearchDiseaseEncyclopediaByCursorScorePageQuery } from '../search.gql.impl';

const useGetKeywordSearchDiseaseEncyclopediaInfiniteQuery = <T>(
  variables: Types.SearchDiseaseEncyclopediaByCursorScorePageQueryVariables,
  queryOptions?: UseInfiniteQueryOptions<Types.SearchDiseaseEncyclopediaByCursorScorePageQuery, AxiosError, T>
) => {
  return useInfiniteQuery<Types.SearchDiseaseEncyclopediaByCursorScorePageQuery, AxiosError, T>(
    useSearchDiseaseEncyclopediaByCursorScorePageQuery.getKey(variables),
    ({ pageParam }) => {
      return useSearchDiseaseEncyclopediaByCursorScorePageQuery.fetcher({
        request: {
          ...variables.request,
          pivotId: pageParam?.pivotId ?? undefined,
          pivotScore: pageParam?.pivotScore ?? undefined,
        },
      })();
    },
    {
      ...queryOptions,
      getNextPageParam: (lastPage: Types.SearchDiseaseEncyclopediaByCursorScorePageQuery) => {
        if (lastPage.searchDiseaseEncyclopediaByCursorScorePage.items.length === variables.request.limit) {
          return {
            pivotId: lastPage.searchDiseaseEncyclopediaByCursorScorePage.pivotId,
            pivotScore: lastPage.searchDiseaseEncyclopediaByCursorScorePage.pivotScore,
          };
        }
        return undefined;
      },
    }
  );
};

export default useGetKeywordSearchDiseaseEncyclopediaInfiniteQuery;
